import { Tooltip, Typography } from '@mui/material';
import { format } from 'date-fns';
import { isString } from 'lodash';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RootStateOrAny, useSelector } from 'react-redux';
import { getFullName } from 'src/common/utils/format-utils';
import { ApplicationStatus } from 'src/enums/application-status.enum';
import { useResources, useSnackbar } from 'src/hooks';
import { getNotifications } from 'src/thunks/notifications-thunk';
import { DataTable, DataTableFilter } from '../data-table';
import { DataTableFooter } from '../data-table/data-table-footer';
import { Page } from '../page';

interface Props {}

const Notifications: FC<Props> = () => {
  const { t } = useTranslation();
  const { showMessage } = useSnackbar();
  const { request } = useSelector((state: RootStateOrAny) => state.notifications);

  const {
    list: { data: hits, isLoading, total },
    query,
    handleQueryUpdate,
    handleFetchCurrentPage,
  } = useResources({
    entity: 'notifications',
    onGetAll: getNotifications,
    defaultParams: {
      embed: 'user',
    },
  });

  console.log('hits', total, hits);

  useEffect(() => {
    if (request?.error && isString(request?.error)) showMessage(request?.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request?.error]);

  // t('APPLICATION.PENDING', 'Заявка подана')
  // t('APPLICATION.CONFIRMED', 'Заявка одобрена')
  // t('APPLICATION.DECLINED', 'Заявка отклонена')
  // t('APPLICATION.PASSED', 'Заявка пройдена')
  // t('APPLICATION.FAILED', 'Заявка не пройдена')
  // t('APPEAL.PENDING', 'Апелляция подана')
  // t('APPEAL.CONFIRMED', 'Апелляция одобрена')
  // t('APPEAL.DECLINED', 'Апелляция отклонена')
  // t('ATTESTATION.ABSENT', 'Отсутствует')
  // t('ATTESTATION.COMPLETED', 'Аттестация пройдена')
  // t('ATTESTATION.STARTED', 'Аттестация начата')
  // t('ATTESTATION.STOPPED', 'Аттестация остановлена')
  // ApplicationStatus {
  //   CONFIRMED
  //   DECLINED
  // }
  // AppealStatus {
  //   PENDING
  //   CONFIRMED
  //   DECLINED
  // }
  // AttestationStatus {
  //   ABSENT
  //   COMPLETED
  //   STARTED
  //   STOPPED
  // }

  const data = {
    hits,
    isLoading,
    columns: [
      {
        width: 120,
        label: '№',
        labelKey: '',
        renderItem: (item: Record<string, any>) => (
          <Typography variant="h5" color="primary">
            {item.taskId}
          </Typography>
        ),
      },
      {
        width: 'auto',
        label: 'ФИО',
        labelKey: 'name.full',
        renderItem: (item: Record<string, any>) => getFullName(item.user),
      },
      {
        width: 'auto',
        label: 'Дата',
        labelKey: 'date',
        renderItem: (item: Record<string, any>) => format(new Date(item.date), 'dd.MM.yyyy HH:mm'),
      },
      {
        width: 'auto',
        label: 'Статус',
        labelKey: 'status',
        renderItem: (item: Record<string, any>) => t(item.notificationStatus),
      },
      {
        width: 'auto',
        label: 'Причина',
        labelKey: 'reason',
        renderItem: (item: Record<string, any>) => item.reason,
      },
      {
        width: 120,
        label: 'Прошли аттестацию',
        labelKey: 'attestation.passed',
        renderItem: (item: Record<string, any>) =>
          item.isPassed !== null && (item.isPassed ? t('yes', 'Да') : t('no', 'Нет')),
        hidden: [
          undefined,
          ApplicationStatus.PENDING,
          ApplicationStatus.DECLINED,
          // ApplicationStatus.PASSED,
          // ApplicationStatus.FAILED,
        ].includes(query.status),
      },
      {
        width: 200,
        label: 'Причина',
        labelKey: 'reason',
        renderItem: (item: Record<string, any>) => (
          <Tooltip title={item.declineReason} placement="bottom-end">
            <Typography
              variant="body3"
              color="error"
              noWrap
              sx={{
                cursor: 'default',
              }}
            >
              {t(item.declineReason)}
            </Typography>
          </Tooltip>
        ),
        hidden: query.status !== ApplicationStatus.DECLINED,
      },
    ],
  };

  return (
    <Page title={t('notifications', 'Уведомления')}>
      {/* panel */}
      <DataTableFilter
        {...{
          value: query.search,
          onUpdate: handleQueryUpdate,
          SearchFieldProps: {
            placeholder: t('action.search.notifications', 'Ф.И.О., ПИНФЛ, серия и номер паспорта'),
          },
        }}
      />

      {/* data table */}
      <DataTable {...data} />

      {/* table footer */}
      <DataTableFooter {...{ total, query, onUpdate: handleQueryUpdate }} />
    </Page>
  );
};

export default Notifications;
